import ListDepartment from './views/List.vue'
import CreateEditDepartment from './views/CreateEdit.vue'
import GetDepartment from './views/Get.vue'

export const DepartmentRoutes = [
  {
    path: '/departments',
    name: 'ListDepartments',
    component: ListDepartment,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'department:list'
    }
  },
  {
    path: '/department',
    name: 'CreateDepartment',
    component: CreateEditDepartment,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'department:create'
    }
  },
  {
    path: '/department/:id',
    name: 'UpdateDepartment',
    component: CreateEditDepartment,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'department:update'
    }
  },
  {
    path: '/department/view/:id',
    name: 'GetDepartment',
    component: GetDepartment,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'department:get'
    }
  }
]
